export default "__VITE_PUBLIC_ASSET__45dfa2b2__"